import React from 'react';

const Tunnel = ({color = '#1976d2', width = 20, height = 20}) => {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 100 100" width={width} height={height}>
            <path
                d="M90.902 75.506c.142 1.222-2.764 2.222-6.46 2.222H66.703c-3.234 0-5.623-1.309-5.813-3.035 1.181-2.23 1.837-5.574 1.837-8.31 0-8.543-6.565-15.469-14.663-15.469-8.098 0-14.663 6.926-14.663 15.469 0 2.929.772 5.667 2.112 8.001.076 1.876-2.395 3.344-5.819 3.344H14.787c-3.342 0-5.541-2.153-5.676-4.971-.068-1.416.053-4.261.246-5.666.716-5.218 3.073-12.652 5.255-17.739C19.08 38.937 27.118 33.57 36.118 35.753c4.884-15.379 27.513-23.688 33.347 9.371 12.573-5.21 18.719 11.553 20.398 21.509.371 2.202 1.039 8.873 1.039 8.873z"
                fill={color}/>
        </svg>
    );
}

export default Tunnel;